module.exports = __webpack_public_path__ + "media/images/icons/icon-connected-dots-5c32b17f6addf3be3eacfe9d145aa5ae.svg";